import { Pipe, PipeTransform } from '@angular/core';
import { Filter } from '../models/filters';

@Pipe({name: 'displayFilter'})
export class DisplayFilterPipe implements PipeTransform {
  transform(filter: Filter): string {
    return filter.displayFunc(filter.item);
  }
}
